import React, { type ReactNode } from "react";
import { NavLink } from "react-router-dom";

export default function QualityWorkspaceNav({ children }: { children: ReactNode }) {
  return (
    <div>
      <nav className="nav nav-tabs mb-3" aria-label="Quality workspace views">
        <NavLink className="nav-link" to="/qa/dashboard">
          Quality Dashboard
        </NavLink>
        <NavLink className="nav-link" to="/qa/consensus">
          Consensus Review
        </NavLink>
        <NavLink className="nav-link" to="/monitoring/signal-quality">
          Signal Quality
        </NavLink>
      </nav>
      {children}
    </div>
  );
}
